module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e47cd5bd430206cefd3a8a5cb4af9138.png";